import { Box, Container, Stack, Text, Link, HStack, Icon } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" bg="gray.50" color="gray.700" py={10}>
      <Container maxW="1200px">
        <Stack direction={{ base: 'column', md: 'row' }} gap={8} justify="space-between">
          <Stack gap={6} align={{ base: 'center', md: 'flex-start' }}>
            <Text fontSize="xl" fontWeight="bold" color="brand.secondary">DIYBuddy</Text>
            <Text>Your home's best friend</Text>
          </Stack>
          
          {/* TEMP REMOVAL */}
          {/* <Stack direction={{ base: 'column', md: 'row' }} spacing={6}>
            <Link href="#">Privacy Policy</Link>
            <Link href="#">Terms of Service</Link>
          </Stack> */}
        </Stack>
        
        <Text pt={8} fontSize="sm" textAlign="center">
          © {new Date().getFullYear()} DIYBuddy. All rights reserved.
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;
